import { useState, useEffect } from "react";

export const useIsNarrowWidth = (widthThreshold = 600): boolean => {
  const [isNarrowWidth, setIsNarrowWidth] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      setIsNarrowWidth(window.innerWidth < widthThreshold);
    };

    checkWidth();

    window.addEventListener("resize", checkWidth);

    return () => window.removeEventListener("resize", checkWidth);
  }, [widthThreshold]);

  return isNarrowWidth;
};
